import './DiagnosticMaterials.css';

import * as React from 'react';

import { Link, RouteComponentProps } from 'react-router-dom';

import Button from '../../../../components/Button/Button';
import Modal from '../../../../components/Modal/Modal';
import BrightcoveVideo from '../../../../components/BrightcoveVideo/BrightcoveVideo';
import { PageContent } from '../../../../components/PageContent/PageContent';
import Loading from '../../../../components/Loading/Loading';
import { getTestDisplayName, getTheEnhancedActPdfLink, isEnhancedActTest } from '../../../../services/utils/practice-test-util';
import { BLOCKED_ENHANCED_ACT_TESTS_FOR_PRINTABLE_MATERIALS } from '../../../../rules/business';

interface Props {
    testName: string;
}

interface State {
    showConfirmationModal: boolean;
    link: string;
    test: string;
    isSAT: boolean;
    isDiagnostic: boolean;
    videoId: string;
    showLoading: boolean;
    showVideoInModal:boolean;
 }

type AllProps = Props & RouteComponentProps<any>;

export class DiagnosticMaterials extends React.Component<AllProps, State> {
    static instance: DiagnosticMaterials

    videoRef = React.createRef<BrightcoveVideo>()

    showVideo = (videoId) => {
        this.setState({showVideoInModal: true, videoId})

        // OT: Loading the video causes flashing, so I first cover it...
        // and after a short time I reveal the video in order to prevent flashing!
        setTimeout(() => {
            this.setState({showLoading: false})
        }, 500)
    }

    handleOnModalClose = () => {
        this.setState({showVideoInModal: false, showLoading: true})
        this.videoRef.current?.pause()
    }

    constructor(props: AllProps) {
        super(props);
        const currentUrl = window.location.href;
        const endingPath = currentUrl.substr(currentUrl.lastIndexOf('/') + 1);
        this.state = {
            showConfirmationModal: false,
            link: props.testName === 'diagnostic' ?
            `/app/practice-tests/instructions/timing/${endingPath}` :
            `/app/practice-tests/instructions/timing/${endingPath}`,
            test: window.location.href.substr(window.location.href.lastIndexOf('/') + 1),
            isSAT: false,
            isDiagnostic: (window.location.href.includes('diagnostic')) ? true : false,
            videoId:'',
            showLoading: false,
            showVideoInModal: false
        };

        DiagnosticMaterials.instance = this
    }

    public render() {
        const urlHash = window.location.hash;
        const fullUrl = window.location.href;
        let currentUrl;
        urlHash ? currentUrl = fullUrl.replace(urlHash, '') : currentUrl = fullUrl;
        let currentTestName = currentUrl.substr(currentUrl.lastIndexOf('/') + 1);
        const imageBasePath = `/assets/images/icons/diagnostic`;
        let type = 'ACT';
        let isSAT = false;
        let isDiagnostic = false;
        let selectedVideoId = this.state.videoId
        let desiredWidth = "80%"
        let bigPlayerStyle = {
            width: '100%',
            maxWidth: '100%',
            height: 'auto'
        }

        if (currentTestName && currentTestName.includes("SAT")) {
            type = 'SAT';
            isSAT = true;
        }
        const endingPath = currentUrl.substr(currentUrl.lastIndexOf('/') + 1);
        let link = `/app/practice-tests/scoring/${endingPath}`;

        if(currentUrl.toLowerCase().includes('diagnostic')) {
            isDiagnostic = true;
            link = `/app/practice-tests/scoring/Diagnostic`;
        }

        if (this.state.test === 'DiagnosticSAT') {
            link = `/app/practice-tests/scoring/DiagnosticSAT`;
        }

        if (currentTestName && currentTestName.includes("EnhancedACT")) {
            // Just go to the paper test link for Enhanced ACTs
            link = `/app/practice-tests/scoring/${currentTestName}`
        }

        let testDisplayName = '';
        let testNumber;
        let isEnhancedACT = isEnhancedActTest(currentTestName)

        if(currentTestName === 'Diagnostic') {
            testDisplayName = 'the ACT Diagnostic';
        } 
        else if (currentTestName === 'EnhancedACTDiagnostic') {
            testDisplayName = 'the Enhanced ACT Diagnostic';
        } 
        else if(currentTestName === 'DiagnosticSAT') {
            testDisplayName = 'the SAT Diagnostic';
        } 
        else if(isEnhancedACT) {
            testNumber = currentTestName.slice(-1);
            testDisplayName = getTestDisplayName(currentTestName)
        }
        else {
            testNumber = currentTestName.slice(-1);
            testDisplayName = currentTestName.substring(0, currentTestName.length - 1) + ' Test ' + testNumber;
        }

        return (
                <PageContent>
                    <div className="combined-instructions">
                        <div className="row mb-4">
                            <StepsToGetReady type={type} testName={currentTestName} />
                        </div>
                        <div className="row mb-4">
                            <div className="col-xl-4 col-tools mb-4 mb-xl-0">
                                <WhatYouNeed />
                            </div>
                            <div className="col-xl-8 col-guides mb-3 mb-xl-0">
                                <div className="diagnostic-instructions inst-block-wrapper">
                                    <ProctoringVideoGuides type={type} testName={currentTestName} />
                                    <TimelineGuides type={type} testName={currentTestName} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 text-center">
                                <div className="diagnostic-instructions inst-block-wrapper">
                                    <div className="diagnostic-button-container">
                                        <h2 className="text-center fw-700">Good luck on your practice exam!</h2>
                                        <p>When you're done taking the exam, you're ready to enter your answers.  You'll get immediate feedback on whether your answer is correct (green) or incorrect (red) with a running total of your accuracy and score. Every question is broken down by lesson and topic with a step-by-step explanation video.</p>
                                        <Button text={`READY TO ENTER ANSWERS`} onClick={e => this.popConfirmationModal(`${link}`)} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Modal
                        className="heading-banner-tc modal diagnostic-confirmation-modal"
                        show={this.state.showConfirmationModal}
                        onClose={this.closeConfirmationModal}
                    >
                        <div className="row">
                        <div className="col-lg-12 text-center">
                                <h2 className="cushion-element-tc">Quick Check</h2>
                            </div>
                            <div className="body-tc container-fluid coverBottom-tc text-center">
                                <p>Have you completed the exam and filled out your printed scantron with your answers?</p>
                                <div>
                                    <Button className="btn btn-info no-wrap" text="NO, GO BACK" onClick={this.closeConfirmationModal} />
                                    <Button className="btn btn--bg-green btn--text-white continue-btn no-wrap" text="YES, CONTINUE" bgColor="green" onClick={e => this.closeAndNext(link)} />
                                </div>

                            </div>
                        </div>
                    </Modal>
                    <Modal
                        show={this.state.showVideoInModal}
                        width={desiredWidth}
                        showXTopRight={true}
                        onClose={() => this.handleOnModalClose()}>
                            <div style={{position:"relative"}}>
                                <BrightcoveVideo 
                                    ref = {this.videoRef}
                                    id={`video-in-modal-${selectedVideoId}`}
                                    videoId={selectedVideoId}
                                    style={bigPlayerStyle}
                                />
                                {this.state.showLoading &&
                                    <div style={{position:"absolute",
                                        height: "100%",
                                        width: "100%",
                                        top: 0,
                                        zIndex: 1,
                                        backgroundColor: "white"}}>
                                        <div style={{position: "absolute", top: "42%", left: "50%"}}>
                                            <div style={{position: "relative", left: "-50%", top: "-50%"}}>
                                                <Loading />
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                    </Modal>
                </PageContent>
            );
    }

    closeAndNext = (link) => {
        this.setState({
            showConfirmationModal: false
        }, () => {
            this.props.history.push(link)
        })
    }

    popConfirmationModal = (link: string) => {
        this.setState({
          showConfirmationModal: true
        });
    }

    closeConfirmationModal = () => {
        this.setState({
            showConfirmationModal: false
        });
    }

    routeTo = (path: string) => {
        let isSAT = path === 'diagnostic' ? false : true;
        let currUrl = window.location.href;
        let isDiagnostic = currUrl.includes('diagnostic') ? true : false;
        this.setState({
            isSAT: isSAT,
            isDiagnostic: isDiagnostic
        }, () => {
            this.props.history.push(path);
        });
    }
}

//--- Helpers ---

/**
 * Steps to get ready for the exam. Currently available exams kept as is.
 * 
 * @param type, testName 
 */
function StepsToGetReady({type, testName}: {type: string, testName: string}) {
    let isEnhancedACT = isEnhancedActTest(testName)

    return (
        isEnhancedACT ?
            <StepsToGetReadyForEnhancedACT type={type} testName={testName}/>
            :
            <StepsToGetReadyForCurrentACTandSAT type={type} testName={testName} />
    )

}

/**
 * Steps to get ready for Enhanced ACTs.
 * Contrary to the current ones, each Enhanced ACT test will have their own dedicated PDFs
 * that could be downloaded by students.
 * 
 * @param type, testName 
 */
function StepsToGetReadyForEnhancedACT({type, testName}: {type: string, testName: string}) {
    let testDisplayName = getTestDisplayName(testName)
    let linkPracticeTest = getTheEnhancedActPdfLink(testName, "/assets/home-pdfs")
    let linkScantron = "/assets/home-pdfs/EnhancedACT_Scantron.pdf"
    let blockedTestsForPrintableMaterials = BLOCKED_ENHANCED_ACT_TESTS_FOR_PRINTABLE_MATERIALS
    let showPrintExamButton = true

    blockedTestsForPrintableMaterials.forEach(blockedTestName =>{
        let normalized1 = testName.trim().toLowerCase()
        let normalized2 = blockedTestName.trim().toLowerCase()

        if (normalized1 === normalized2) {
            showPrintExamButton = false
        }
    })

    return (
         <div className="col-12">
            <div className="diagnostic-instructions inst-block-wrapper row no-gutters">
                <div className="col-lg-4 order-lg-2">
                    <div className="act-logo-container">
                        <p className="act-logo-holder">
                            <img src="/assets/images/badge-act.png" alt="ACT Logo" />
                        </p>
                    </div>
                </div>
                <div className="col-lg-8">
                    <h2 className="fw-700 text-center text-md-left">Steps to Get Ready for {testDisplayName}</h2>
                    <ul className="instruction-list">
                        <li className="list-check">Print the exam and scantron by clicking the buttons below</li>
                        <li className="list-check">Find a quiet space to emulate real testing conditions</li>
                        <li className="list-check">Self-proctor by following along with the section times provided below</li>
                        <li className="list-check">Put a star next to any question on which you guess, so you remember to go back and review</li>
                    </ul>
                    <div className="text-center text-md-left">
                        {showPrintExamButton && 
                            <a className="btn btn--text-white btn--bg-blue mr-sm-2 mx-md-1 mt-2" href={linkPracticeTest} target="_blank" title="PRINT THE EXAM">PRINT THE EXAM</a>
                        }
                        <a className="btn btn--text-white btn--bg-green mx-md-1 mt-2" href={linkScantron} target="_blank" title="DOWNLOAD SCANTRON">DOWNLOAD SCANTRON</a>
                    </div>
                </div>
            </div>
        </div>
    )
}

/**
 * The current tests are displayed just like before in the "steps to get" ready section.
 * 
 * @param type, testName 
 */
function StepsToGetReadyForCurrentACTandSAT({type, testName}: {type: string, testName: string}) {
    let testDisplayName = getTestDisplayName(testName)
    let isDiagnostic = testName.toLowerCase().includes("diagnostic")

    return (
        <div className="col-12">
            <div className="diagnostic-instructions inst-block-wrapper row no-gutters">
                <div className="col-lg-4 order-lg-2">
                {
                    type === 'ACT' &&
                    <div className="act-logo-container">
                        <p className="act-logo-holder">
                            <img src="/assets/images/badge-act.png" alt="ACT Logo" />
                        </p>
                    </div>
                }
                {
                    type === 'SAT' &&
                    <div className="act-logo-container">
                        <p className="act-logo-holder">
                            <img src="/assets/images/badge-sat.png" alt="SAT Logo" />
                        </p>
                    </div>
                }
                </div>
                <div className="col-lg-8">
                    <h2 className="fw-700 text-center text-md-left">Steps to Get Ready for {testDisplayName}</h2>
                    <ul className="instruction-list">
                        {type === 'ACT' && testName !== 'Diagnostic' &&
                            <li className="list-check">Print the scantron and open the ACT Official Guide to the appropriate test. <a target="_blank" href="https://www.winwardacademy.com/contact/" title="Contact Us">Contact us</a> if you have trouble locating the ACT practice exam</li>
                        }
                        {type === 'ACT' && testName === 'Diagnostic' &&
                            <li className="list-check">Print the exam and scantron by clicking the buttons below</li>
                        }
                        {type === 'SAT' &&
                            <li className="list-check">Print the exam and scantron by clicking the buttons below</li>
                        }
                        <li className="list-check">Find a quiet space to emulate real testing conditions</li>
                        <li className="list-check">Self-proctor by following along with the video guides or section times provided below</li>
                        <li className="list-check">Put a star next to any question on which you guess, so you remember to go back and review</li>
                    </ul>
                    { type === 'SAT' && isDiagnostic &&
                        <div className="text-center text-md-left">
                            <a className="btn btn--text-white btn--bg-blue mr-sm-2 mx-md-1 mt-2" href={`/assets/sat/SATDiagnostic.pdf`} target="_blank" title="PRINT THE EXAM">PRINT THE EXAM</a>
                            <a className="btn btn--text-white btn--bg-green mx-md-1 mt-2" href={`/assets/sat/SATScantron.pdf`} target="_blank" title="DOWNLOAD SCANTRON">DOWNLOAD SCANTRON</a>
                        </div>
                    }
                    { type === 'SAT' && !isDiagnostic &&
                        <div className="text-center text-md-left">
                        <a className="btn btn--text-white btn--bg-blue mr-sm-2 mx-md-1 mt-2" href={`/assets/sat/${testName}.pdf`} target="_blank" title="PRINT THE EXAM">PRINT THE EXAM</a>
                        <a className="btn btn--text-white btn--bg-green mx-md-1 mt-2" href={`/assets/sat/SATScantron.pdf`} target="_blank" title="DOWNLOAD SCANTRON">DOWNLOAD SCANTRON</a>
                        </div>
                    }
                    { type === 'ACT' && isDiagnostic &&
                        <div className="text-center text-md-left">
                            <a className="btn btn--text-white btn--bg-blue mr-sm-2 mx-md-1 mt-2" href={`/assets/home-pdfs/ACT2018Diagnostic.pdf`} target="_blank" title="PRINT THE EXAM">PRINT THE EXAM</a>
                            <a className="btn btn--text-white btn--bg-green mx-md-1 mt-2" href={`/assets/home-pdfs/ACTScantron.pdf`} target="_blank" title="DOWNLOAD SCANTRON">DOWNLOAD SCANTRON</a>
                        </div>
                    }
                    { type === 'ACT' && !isDiagnostic &&
                        <div className="text-center text-md-left">
                            <a href="/assets/home-pdfs/ACTScantron.pdf" target="_blank" className="btn btn--text-white btn--bg-blue mx-1" title="DOWNLOAD SCANTRON">DOWNLOAD SCANTRON</a>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

/**
 * Displays what the student will need to take the pracatice test.
 * 
 */
function WhatYouNeed() {
    let [wyneeds, _setWyn] = new Array([
        {name: "No 2 pencils", img: "pencil.svg"},
        {name: "Calculator", img: "calculator.svg"},
        {name: "Timer or stopwatch", img: "timer.svg"},
        {name: "Printed exam", img: "exam.svg"},
        {name: "Printed scantron", img: "scantron.svg"},
        {name: "Quiet space", img: "lamp.svg"}
    ])

    return (
        <div className="diagnostic-instructions inst-block-wrapper">
            <div className="row h-100 no-gutters">
            <h2 className="text-center fw-700 mb-2 mb-md-4 w-100">What You'll <br className="d-block d-md-none" />Need</h2>
                {wyneeds.map( (wyn,index)=> (
                    <div className="col-sm-6 col-lg-4 col-xl-12 mb-4 material-card">
                        <div className="tool-icons">
                            <div className="tool-icons--iconWrapper wa-blue-background">
                                <img alt="" src={`/assets/images/icons/diagnostic/` + wyn.img} className="diagnostic-icon" />
                            </div>
                            <p className="tool-icons--label pr-md-3 pr-xl-0">{wyn.name}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

/**
 * Proctoring video guides for ACT & SAT paper tests
 * @param type and testName 
 */
function ProctoringVideoGuides({type, testName}: {type: string, testName: string}) {
    return type === "SAT" ? 
        <ProctoringVideoGuidesSAT />
        :
        <ProctoringVideoGuidesACT testName={testName} />
}

/**
 * ACT family (ACT | Enhanced ACT | IA) proctoring video guides
 * @param testName 
 */
function ProctoringVideoGuidesACT({testName} : {testName: string}) {
    let isEnhancedACT = isEnhancedActTest(testName)

    return isEnhancedACT ? 
        <ProctoringVideoGuidesEnhancedACT /> 
        : 
        <ProctoringVideoGuidesRegularACT />
}

/**
 * Enhanced ACT proctoring video guides
 */
function ProctoringVideoGuidesEnhancedACT() {
    // Just like SATs new Enhanced ACTs won't have proctoring videos (per Jennifer - 22 Dec 2025/Mon)
    // I kept the inital info below just in case if we need to provide videos again!
    return (
        <div>

        </div>
    )
}

// OT: Not Used (kept for future reference)
function ProctoringVideoGuidesEnhancedACT_NOT_USED() {
    let ctaButtonClass = 'btn btn--text-white btn--bg-blue mx-md-1 mt-2'
    let ctaButtonClassAlt = 'btn btn--text-white btn--bg-green mx-md-1 mt-2'
    let ctaRegularSuffix = 'REGULAR TIME'
    let ctaExtendedSuffix = 'EXTENDED TIME'

    // Jenifer may have new videos for this!
    // In that case new videos with the new video ids will be used!

    return (
        <div>
            <div className="text-center text-xl-left">
                <h2 className="fw-700 py-0">Enhanced ACT Proctoring Video Guides</h2>
                <p className="mb-4">If you're looking to follow along with a proctoring video that times each section, gives 5 minute warnings, and provides tips along the way, use the regular, 1.5x, 2x, and 3x extended time guides:</p>
                <b>Temp Note:</b> <b><i>Jennifer</i></b> may have more videos for Enhanced ACTs (or maybe not)! She may change the writeup and/or timing related info!
            </div>

            <div className="mb-5 text-center text-xl-left">
                <button className={ctaButtonClass} onClick={() => DiagnosticMaterials.instance.showVideo("6268507970001")} title={`ACT ` + ctaRegularSuffix + `, opens a modal window`}>EHNANCED ACT {ctaRegularSuffix}</button>
                <button className={ctaButtonClassAlt} onClick={() => DiagnosticMaterials.instance.showVideo("6268505297001")} title={`ACT ` + ctaExtendedSuffix + `, opens a modal window`}>EHNANCED ACT {ctaExtendedSuffix}</button>
            </div>
        </div>
    )
}

/**
 * Regular ACT proctoring video guides
 */
function ProctoringVideoGuidesRegularACT() {
    let ctaButtonClass = 'btn btn--text-white btn--bg-blue mx-md-1 mt-2'
    let ctaButtonClassAlt = 'btn btn--text-white btn--bg-green mx-md-1 mt-2'
    let ctaRegularSuffix = 'REGULAR TIME'
    let ctaExtendedSuffix = '1.5 EXTENDED TIME'

    return (
        <div>
            <div className="text-center text-xl-left">
                <h2 className="fw-700 py-0">Proctoring Video Guides</h2>
                <p className="mb-4">If you're looking to follow along with a proctoring video that times each section, gives 5 minute warnings, and provides tips along the way, use the regular or 1.5x extended time guides:</p>
            </div>

            <div className="mb-5 text-center text-xl-left">
                 <div>
                    <button className={ctaButtonClass} onClick={() => DiagnosticMaterials.instance.showVideo("6268507970001")} title={`ACT ` + ctaRegularSuffix + `, opens a modal window`}>ACT {ctaRegularSuffix}</button>
                    <button className={ctaButtonClassAlt} onClick={() => DiagnosticMaterials.instance.showVideo("6268505297001")} title={`ACT ` + ctaExtendedSuffix + `, opens a modal window`}>ACT {ctaExtendedSuffix}</button>
                </div>
            </div>
        </div>
    )
}

/**
 * SAT proctoring video guides
 */
function ProctoringVideoGuidesSAT() {
    // Hmm! Currently there is no video guidelines for the SAT!

    return (
        <div>

        </div>
    )
}

/**
 * Timeline guides for the tests
 * 
 * @param type, testName
 */
function TimelineGuides({type, testName}: {type: string, testName: string}) {
    return (
        <div>
            <h2 className="fw-700">Guide Timelines</h2>
            {
                type === "SAT" ?
                    <TimelineGuidesSAT />
                    :
                    <TimelineGuidesACT testName={testName}/>
            }
        </div>
    )
}

function TimelineGuidesSAT() {
    return (
        <div className="row no-gutters">
            <div className="col-12">
                <div className="timing-table  mb-3 mb-xl-5">
                    <div className="timing-table--inner wide">
                        <div className="row black no-gutters timing-table--header">
                            <div className="col-first" style={{borderBottom: "2px solid #C7CACA"}}>
                                <p className="fw-700 mb-none section-header">EXAM TIMING</p>
                            </div>
                            <div className="col" style={{borderBottom: "2px solid #f29000"}}>
                                <p className="mb-none section-header">R&W Module 1</p>
                            </div>
                            <div className="col" style={{borderBottom: "2px solid #9d59cf"}}>
                                <p className="mb-none section-header">R&W Module 2</p>
                            </div>
                            <div className="col col-break" style={{borderBottom: "2px solid #0E5682"}}>
                                <p className="mb-none section-header">BREAK</p>
                            </div>
                            <div className="col" style={{borderBottom: "2px solid #31b8d4"}}>
                                <p className="mb-none section-header">Math Module 1</p>
                            </div>
                            <div className="col" style={{borderBottom: "2px solid #31b8d4"}}>
                                <p className="mb-none section-header">Math Module 2</p>
                            </div>
                        </div>
                        <div className="row no-gutters flex-no-wrap timing-table--row">
                            <div className="col-first">
                                <p className="timing-table--label">Regular Time</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">39min</p>
                            </div>                                                               
                            <div className="col">
                                <p className="timing-table--value">39min</p>
                            </div>
                            <div className="col col-break">
                                <p className="timing-table--value">10min</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">43min</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">43min</p>
                            </div>
                        </div>
                        <div className="row no-gutters flex-no-wrap timing-table--row last">
                            <div className="col-first">
                            <p className="timing-table--label">1.5 Extended Time</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">59min</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">59min</p>
                            </div>
                            <div className="col col-break">
                                <p className="timing-table--value">15min</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">65min</p>
                            </div>                                                                
                            <div className="col">
                                <p className="timing-table--value">65min</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row no-gutters">
                    <div className="">
                        <p className="">
                            Use your break wisely to recharge. Get a snack, use the restroom, wash your face with cold water, do jumping jacks, whatever you need to stay focused.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

function TimelineGuidesACT({testName}: {testName: string}) {
    let isEnhanceACT = isEnhancedActTest(testName)

    return isEnhanceACT ?
        <TimelineGuidesEnhancedACT />
        :
        <TimelineGuidesRegularACT />
}


function TimelineGuidesEnhancedACT() {
    return (
        <div className="row no-gutters">
            <div className="col-12">
                <div className="timing-table mb-3 mb-xl-5">
                    <div className="timing-table--inner">
                        <div className="row black no-gutters timing-table--header">
                            <div className="col-first" style={{borderBottom: "2px solid #C7CACA"}}>
                                <p className="mb-none section-header">EXAM TIMING</p>
                            </div>
                            <div className="col" style={{borderBottom: "2px solid #9d59cf"}}>
                                <p className="mb-none section-header">ENGLISH</p>
                            </div>
                            <div className="col" style={{borderBottom: "2px solid #31b8d4"}}>
                                <p className="mb-none section-header">MATH</p>
                            </div>
                            <div className="col" style={{borderBottom: "2px solid #0E5682"}}>
                                <p className="mb-none section-header">BREAK</p>
                            </div>
                            <div className="col" style={{borderBottom: "2px solid #f29000"}}>
                                <p className="mb-none section-header">READING</p>
                            </div>
                            <div className="col" style={{borderBottom: "2px solid #78b821"}}>
                                <p className="mb-none section-header">SCIENCE</p>
                            </div>
                        </div>
                        <div className="row no-gutters flex-no-wrap timing-table--row">
                            <div className="col-first">
                                <p className="timing-table--label">Regular Time</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">35min</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">50min</p>
                            </div>
                            <div className="col col-break">
                                <p className="timing-table--value">10min</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">40min</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">40min</p>
                            </div>
                        </div>
                        <div className="row no-gutters flex-no-wrap timing-table--row last">
                            <div className="col-first">
                                <p className="timing-table--label">1.5x Time</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">53min</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">75min</p>
                            </div>
                            <div className="col col-break">
                                <p className="timing-table--value">15min</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">60min</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">60min</p>
                            </div>
                        </div>
                        <div className="row no-gutters flex-no-wrap timing-table--row last">
                            <div className="col-first">
                                <p className="timing-table--label">2x Time</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">70min</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">100min</p>
                            </div>
                            <div className="col col-break">
                                <p className="timing-table--value">20min</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">80min</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">80min</p>
                            </div>
                        </div>
                        <div className="row no-gutters flex-no-wrap timing-table--row last">
                            <div className="col-first">
                                <p className="timing-table--label">3x Time</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">105min</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">150min</p>
                            </div>
                            <div className="col col-break">
                                <p className="timing-table--value">30min</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">120min</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">120min</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row no-gutters">
                    <div className="">
                        <p className="">
                            <b>You only have one break</b>, so use it wisely to recharge and focus on the-back-to-back reading and science sections. Get a snack, use the restroom, wash your face with cold water, do jumping jacks, whatever you need to recharge and stay focused for the second half.
                        </p>
                        <p className="mb-0">
                            If you're taking the ACT without Writing, you're done after Science. If you're taking the ACT with Writing, then you would complete the 40 minute essay (60 minutes for 1.5x extended time).
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

function TimelineGuidesRegularACT() {
    return (
        <div className="row no-gutters">
            <div className="col-12">
                <div className="timing-table mb-3 mb-xl-5">
                    <div className="timing-table--inner">
                        <div className="row black no-gutters timing-table--header">
                            <div className="col-first" style={{borderBottom: "2px solid #C7CACA"}}>
                                <p className="mb-none section-header">EXAM TIMING</p>
                            </div>
                            <div className="col" style={{borderBottom: "2px solid #9d59cf"}}>
                                <p className="mb-none section-header">ENGLISH</p>
                            </div>
                            <div className="col" style={{borderBottom: "2px solid #31b8d4"}}>
                                <p className="mb-none section-header">MATH</p>
                            </div>
                            <div className="col" style={{borderBottom: "2px solid #0E5682"}}>
                                <p className="mb-none section-header">BREAK</p>
                            </div>
                            <div className="col" style={{borderBottom: "2px solid #f29000"}}>
                                <p className="mb-none section-header">READING</p>
                            </div>
                            <div className="col" style={{borderBottom: "2px solid #78b821"}}>
                                <p className="mb-none section-header">SCIENCE</p>
                            </div>
                        </div>
                        <div className="row no-gutters flex-no-wrap timing-table--row">
                            <div className="col-first">
                                <p className="timing-table--label">Regular Time</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">45min</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">60min</p>
                            </div>
                            <div className="col col-break">
                                <p className="timing-table--value">10min</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">35min</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">35min</p>
                            </div>
                        </div>
                        <div className="row no-gutters flex-no-wrap timing-table--row last">
                            <div className="col-first">
                            <p className="timing-table--label">1.5 Extended Time</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">70min</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">90min</p>
                            </div>
                            <div className="col col-break">
                                <p className="timing-table--value">15min</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">55min</p>
                            </div>
                            <div className="col">
                                <p className="timing-table--value">55min</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row no-gutters">
                    <div className="">
                        <p className="">
                            <b>You only have one break</b>, so use it wisely to recharge and focus on the-back-to-back reading and science sections. Get a snack, use the restroom, wash your face with cold water, do jumping jacks, whatever you need to recharge and stay focused for the second half.
                        </p>
                        <p className="mb-0">
                            If you're taking the ACT without Writing, you're done after Science. If you're taking the ACT with Writing, then you would complete the 40 minute essay (60 minutes for 1.5x extended time).
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

